import { render } from "./ErrorMessage.vue?vue&type=template&id=7f24af30"
import script from "./ErrorMessage.vue?vue&type=script&lang=ts"
export * from "./ErrorMessage.vue?vue&type=script&lang=ts"

import "./ErrorMessage.vue?vue&type=style&index=0&id=7f24af30&lang=scss"
script.render = render

export default script